module.exports = __webpack_public_path__ + "img/品質管理1-11.577f844b.png";